import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'
import sizes from '../../theme/foundations/sizes'

export const flexStyle = {
    direction: 'row',
    align: 'flex-start',
    width: '100%',
    justify: {
        base: 'space-between',
        md: 'flex-start'
    },
    gap: 2
}

export const hStackStyle = {
    flex: '1',
    minW: 0,
    align: 'flex-start',
    alignItems: 'flex-start'
}

export const tagIconStyle = {
    w: pxToRem(16.17),
    h: pxToRem(16.17),
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    flex: 'none',
    mt: pxToRem(3),
    [`@media (max-width: ${sizes.container.md})`]: {
        width: pxToRem(16.17),
        height: pxToRem(16.17)
    }
}

export const calloutBoxStyle = {
    flex: '1',
    minW: 0,
    overflowWrap: 'break-word',
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: 400,
    color: 'cav_light_input_gray',
    letterSpacing: pxToRem(1),
    lineHeight: 'normal',
    m: 0,
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(12),
        letterSpacing: pxToRem(1),
        lineHeight: 'normal'
    },
    '& a': {
        color: 'cav_light_input_gray',
        textDecoration: 'none',
        _hover: {
            color: 'red.cvs'
        }
    }
}
